import styled from '@emotion/styled'
import { Box } from '@mui/material'
import { colors } from '@resiliatech/birdsong'

export const GoalProgressContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
`

export const GoalTitle = styled(Box)`
  cursor: pointer;
  font-size: 16px;
`

export const GoalProgressCardsContainer = styled(Box)`
  max-height: 400px;
  padding-right: 8px;
  overflow-y: auto;
`

export const GoalProgressCardContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const goalChipColors = {
  category: colors.feedback.infoLight,
  priority: colors.warning.light,
  completed: colors.feedback.successLight,
  informational: colors.background.paper,
}

const getBorderColor = (
  variant?: 'category' | 'priority' | 'completed' | 'informational'
) => {
  if (variant === 'informational') {
    return `1px solid ${colors.text.disabled}`
  }
  if (variant) {
    return `1px solid ${goalChipColors[variant]}`
  }
  return `1px solid ${colors.interactive.disabledLight}`
}

export const GoalChip = styled(Box)<{
  variant?: 'category' | 'priority' | 'completed' | 'informational'
}>`
  align-items: center;
  background-color: ${({ variant }) => variant && goalChipColors[variant]};
  border: ${({ variant }) => getBorderColor(variant)};
  border-radius: 4px;
  color: ${colors.copy.paragraphDark};
  display: flex;
  gap: 6px;
  padding: 3px 6px;
`

export const GoalChipContainer = styled(Box)`
  display: flex;
  gap: 10px;
`
